import store from './reducers';

export default store;
